import * as types from "./actionTypes";
import * as exception from "./exceptionActions";

export function loadSettings() {
	return function (dispatch) {
		const settings = {};
		if (!window.settings) {
			dispatch(exception.throwException("No valid settings from api"));
			return;
		}

		settings.portalRoot = window.settings.portalRoot;
		settings.helpdeskContactLink = window.settings.helpdeskContactLink;
		settings.fileTypes = window.settings.fileTypes;
		settings.maxAllowedContentLength = window.settings.maxAllowedContentLength;
		settings.sportDBUrl = window.settings.sportDBUrl;

		settings.apiRoot = "/nado.medicijnen.webapi/api";
		settings.siteRoot = "/nado.medicijnen.portal";

		dispatch(readSettingsSuccess(settings));
	};
}

export function getSettings() {
	return (dispatch, getState) => {
		const state = getState();
		return state;
	};
}

export function setAccount(accountId, accountType) {
	return function (dispatch) {
		dispatch(accountSet(accountId, accountType));
	};
}

export function disablePage(disablePage) {
	return function (dispatch) {
		dispatch(disablePageSet(disablePage));
	};
}

export function readSettingsSuccess(settings) {
	return {
		type: types.READ_SETTINGS_SUCCESS,
		data: settings
	};
}

export function accountSet(accountId, accountType) {
	return {
		type: types.ACCOUNT_SET,
		accountId: accountId,
		accountType: accountType
	};
}

export function disablePageSet(disablePage) {
	return {
		type: types.DISABLE_PAGE,
		disablePage: disablePage
	};
}

